export const translations = {
    en: {
        nav: {
            links: ["Home", "Services", "Portfolio", "Process", "Technologies", "Testimonials", "About", "Contact"],
            cta: "Start Project",
        },
        hero: {
            overline: "Overlast Studio — Web & Android Development",
            line1: "Turning Ideas into",
            line2: "Powerful Digital",
            line3: "Products.",
            sub: "I design and develop modern websites and Android applications that help businesses grow.",
            ctaPrimary: "Start Your Project",
            ctaSecondary: "View My Work",
            scroll: "Scroll",
        },
        marquee: [
            "DESIGNING THE FUTURE",
            "BUILDING DIGITAL EXPERIENCES",
            "OVERLAST STUDIO",
            "WEB · ANDROID · AI",
        ],
        services: {
            number: "01",
            label: "Services",
            title: "What I build for ambitious businesses",
            description: "From high-converting websites to native Android apps — every product is engineered for performance, polish, and growth.",
            cards: [
                {
                    title: "Website Development",
                    description: "High-performance websites engineered to convert visitors into customers.",
                    items: ["Company websites", "Landing pages", "E-commerce stores", "Custom web applications", "AI integrations", "Booking systems"],
                },
                {
                    title: "Android App Development",
                    description: "Native Android apps that feel fast, polished, and effortless to use.",
                    items: ["Native Android apps", "Business applications", "AI-powered apps", "Utility apps", "Productivity apps", "API integrations"],
                },
                {
                    title: "UI/UX Design",
                    description: "Interfaces designed with intent — beautiful, intuitive, and built to perform.",
                    items: ["Modern interfaces", "Wireframes", "User experience optimization", "Responsive design"],
                },
            ],
        },
        portfolio: {
            number: "02",
            label: "Portfolio",
            title: "Selected work that shipped and performed",
            description: "A few projects that show how I turn complex requirements into products people love to use.",
            viewProject: "View Project",
            projects: [
                { title: "Nova Analytics", description: "A real-time SaaS analytics platform with custom dashboards, revenue tracking, and AI-driven insights for e-commerce brands." },
                { title: "PulseFit", description: "A native Android fitness app with workout plans, wearable sync, and offline-first architecture. 50k+ downloads." },
                { title: "Atelier Commerce", description: "A premium e-commerce experience for a design furniture brand — bespoke UI system, headless checkout, 98 Lighthouse score." },
            ],
        },
        process: {
            number: "03",
            label: "Process",
            title: "A proven path from idea to launch",
            description: "No chaos, no surprises — a transparent process refined over dozens of successful projects.",
            stepTemplate: "Step {n}",
            steps: [
                { title: "Discovery", description: "We dig into your goals, audience, and constraints to define exactly what success looks like." },
                { title: "Planning", description: "A clear roadmap with milestones, architecture decisions, and transparent estimates." },
                { title: "Design", description: "Wireframes evolve into pixel-perfect interfaces, validated with you at every step." },
                { title: "Development", description: "Clean, scalable code built in iterative sprints with regular progress demos." },
                { title: "Testing", description: "Rigorous QA across devices, performance audits, and edge-case hardening." },
                { title: "Launch", description: "Smooth deployment with monitoring, analytics, and a go-live checklist." },
                { title: "Support", description: "Ongoing maintenance, improvements, and a partner who answers when you call." },
            ],
        },
        technologies: {
            number: "04",
            label: "Technologies",
            title: "A modern stack, mastered end to end",
            description: "The tools I use daily to ship fast, reliable, and scalable digital products.",
        },
        why: {
            number: "05",
            label: "Why Choose Me",
            title: "Results you can measure, quality you can feel",
            stats: ["Projects Completed", "Happy Clients", "Years Experience", "Apps Delivered"],
            points: ["Fast Delivery", "Modern Design", "Mobile First", "SEO Optimized", "Clean Code", "Scalable Architecture", "Ongoing Support"],
        },
        testimonials: {
            number: "06",
            label: "Testimonials",
            title: "What clients say after launch day",
            ratingLabel: "5 star rating",
            items: [
                { quote: "Attila rebuilt our entire platform in eight weeks. Page speed doubled, conversions jumped 34%, and the codebase is a joy to work with. Easily the best hire we've made.", role: "Founder, Bloom & Co." },
                { quote: "Rare combination of engineering depth and design taste. He challenged our assumptions, shipped ahead of schedule, and the Android app he built holds a 4.8-star rating.", role: "CEO, TechFlow" },
                { quote: "Communication was flawless from day one. Weekly demos, honest estimates, zero surprises. Our booking system now runs itself — we just watch the reservations come in.", role: "Product Lead, StartupHub" },
            ],
        },
        about: {
            number: "07",
            label: "About Me",
            title: "A developer who treats your product like his own",
            paragraph: "I'm a professional developer passionate about building beautiful, high-performance digital products. Over the past five years I've helped startups and established businesses ship websites and Android apps that are fast, reliable, and designed to convert. I work as a partner, not a vendor — invested in your outcome from the first call to long after launch.",
            values: [
                { title: "Quality", description: "Every pixel and every line of code is deliberate." },
                { title: "Communication", description: "Clear updates, honest timelines, no jargon." },
                { title: "Innovation", description: "Modern stacks and AI where they create real value." },
                { title: "Problem Solving", description: "Complex requirements turned into elegant products." },
            ],
        },
        contact: {
            number: "08",
            label: "Contact",
            title: "Let's build something exceptional",
            description: "Tell me about your project — I reply to every enquiry personally, usually within 24 hours.",
            labels: { name: "Name *", email: "Email *", company: "Company", budget: "Budget", projectType: "Project Type", message: "Message *" },
            placeholders: { name: "Your name", email: "you@company.com", company: "Company name", message: "Tell me about your goals, timeline, and anything else that matters." },
            selectBudget: "Select a range",
            budgetOptions: ["Under $1,000", "$1,000 – $5,000", "$5,000 – $10,000", "$10,000+"],
            selectType: "What are we building?",
            typeOptions: ["Website", "Web Application", "Android App", "UI/UX Design", "Something else"],
            errors: {
                name: "Please enter your name.",
                email: "Please enter a valid email address.",
                message: "Tell me a bit more about your project (min. 10 characters).",
            },
            submit: "Send Message",
            sending: "Sending…",
            toastSuccess: "Message sent — I'll get back to you within 24 hours.",
            toastError: "Something went wrong. Please try again or email me directly.",
        },
        footer: {
            copyright: "© 2026 Overlast Studio — Attila Zsók. All rights reserved.",
        },
    },
    hu: {
        nav: {
            links: ["Kezdőlap", "Szolgáltatások", "Portfólió", "Munkafolyamat", "Technológiák", "Vélemények", "Rólam", "Kapcsolat"],
            cta: "Projekt indítása",
        },
        hero: {
            overline: "Overlast Studio — Web- és Android-fejlesztés",
            line1: "Ötleteket alakítok",
            line2: "Hatékony Digitális",
            line3: "Termékekké.",
            sub: "Modern weboldalakat és Android alkalmazásokat tervezek és fejlesztek, amelyek segítik vállalkozásod növekedését.",
            ctaPrimary: "Indítsd el a projekted",
            ctaSecondary: "Munkáim megtekintése",
            scroll: "Görgess",
        },
        marquee: [
            "A JÖVŐ TERVEZÉSE",
            "DIGITÁLIS ÉLMÉNYEK ÉPÍTÉSE",
            "OVERLAST STUDIO",
            "WEB · ANDROID · AI",
        ],
        services: {
            number: "01",
            label: "Szolgáltatások",
            title: "Amit ambiciózus vállalkozásoknak építek",
            description: "A magas konverziós weboldalaktól a natív Android alkalmazásokig — minden terméket a teljesítményre, a letisztultságra és a növekedésre tervezek.",
            cards: [
                {
                    title: "Weboldal-fejlesztés",
                    description: "Nagy teljesítményű weboldalak, amelyek a látogatókat ügyfelekké alakítják.",
                    items: ["Céges weboldalak", "Landing oldalak", "Webshopok", "Egyedi webalkalmazások", "AI-integrációk", "Foglalási rendszerek"],
                },
                {
                    title: "Android appfejlesztés",
                    description: "Natív Android alkalmazások, amelyek gyorsak, letisztultak és könnyedén használhatók.",
                    items: ["Natív Android alkalmazások", "Üzleti alkalmazások", "AI-alapú alkalmazások", "Segédalkalmazások", "Produktivitási alkalmazások", "API-integrációk"],
                },
                {
                    title: "UI/UX tervezés",
                    description: "Szándékosan megtervezett felületek — szépek, intuitívak és teljesítményorientáltak.",
                    items: ["Modern felületek", "Drótvázak", "Felhasználói élmény optimalizálása", "Reszponzív dizájn"],
                },
            ],
        },
        portfolio: {
            number: "02",
            label: "Portfólió",
            title: "Elkészült munkák, amelyek eredményeket hoztak",
            description: "Néhány projekt, amely megmutatja, hogyan alakítok összetett igényekből szerethető termékeket.",
            viewProject: "Projekt megtekintése",
            projects: [
                { title: "Nova Analytics", description: "Valós idejű SaaS analitikai platform egyedi irányítópultokkal, bevételkövetéssel és AI-alapú elemzésekkel e-kereskedelmi márkák számára." },
                { title: "PulseFit", description: "Natív Android fitness alkalmazás edzéstervekkel, okosóra-szinkronizálással és offline-first architektúrával. Több mint 50 000 letöltés." },
                { title: "Atelier Commerce", description: "Prémium e-kereskedelmi élmény egy designbútor-márkának — egyedi UI rendszer, headless pénztár, 98-as Lighthouse pontszám." },
            ],
        },
        process: {
            number: "03",
            label: "Munkafolyamat",
            title: "Biztos út az ötlettől a beindításig",
            description: "Káosz és meglepetések nélkül — átlátható folyamat, amelyet több tucat sikeres projekt során csiszoltam.",
            stepTemplate: "{n}. lépés",
            steps: [
                { title: "Felfedezés", description: "Mélyre ásunk a céljaidban, a célközönségedben és a korlátokban, hogy pontosan meghatározzuk, mit jelent a siker." },
                { title: "Tervezés", description: "Világos ütemterv mérföldkövekkel, architektúra-döntésekkel és átlátható becslésekkel." },
                { title: "Dizájn", description: "A drótvázakból pixelpontos felületek lesznek, amelyeket minden lépésnél veled egyeztetek." },
                { title: "Fejlesztés", description: "Tiszta, skálázható kód iteratív sprintekben, rendszeres demókkal az előrehaladásról." },
                { title: "Tesztelés", description: "Alapos minőségellenőrzés különböző eszközökön, teljesítményauditok és a szélsőséges esetek kezelése." },
                { title: "Indítás", description: "Zökkenőmentes élesítés monitorozással, analitikával és indulási ellenőrzőlistával." },
                { title: "Támogatás", description: "Folyamatos karbantartás, továbbfejlesztések és egy partner, aki akkor is válaszol, amikor hívod." },
            ],
        },
        technologies: {
            number: "04",
            label: "Technológiák",
            title: "Modern technológiai stack, elejétől a végéig",
            description: "Az eszközök, amelyekkel nap mint nap gyors, megbízható és skálázható digitális termékeket készítek.",
        },
        why: {
            number: "05",
            label: "Miért engem válassz",
            title: "Mérhető eredmények, érezhető minőség",
            stats: ["Befejezett projektek", "Elégedett ügyfelek", "Év tapasztalat", "Leszállított alkalmazások"],
            points: ["Gyors szállítás", "Modern dizájn", "Mobil-first szemlélet", "SEO-optimalizált", "Tiszta kód", "Skálázható architektúra", "Folyamatos támogatás"],
        },
        testimonials: {
            number: "06",
            label: "Vélemények",
            title: "Mit mondanak az ügyfelek az indulás után",
            ratingLabel: "5 csillagos értékelés",
            items: [
                { quote: "Attila nyolc hét alatt újjáépítette az egész platformunkat. Az oldal sebessége megduplázódott, a konverzió 34%-kal nőtt, és öröm ezzel a kódbázissal dolgozni. Kétségkívül a legjobb döntésünk volt.", role: "Alapító, Bloom & Co." },
                { quote: "Ritka párosítás: mérnöki mélység és dizájnérzék. Megkérdőjelezte a feltevéseinket, határidő előtt szállított, és az általa készített Android alkalmazás 4,8 csillagos értékelésen áll.", role: "CEO, TechFlow" },
                { quote: "A kommunikáció az első naptól fogva hibátlan volt. Heti demók, őszinte becslések, nulla meglepetés. A foglalási rendszerünk most magától működik — csak nézzük, ahogy érkeznek a foglalások.", role: "Termékvezető, StartupHub" },
            ],
        },
        about: {
            number: "07",
            label: "Rólam",
            title: "Egy fejlesztő, aki úgy kezeli a termékedet, mintha a sajátja lenne",
            paragraph: "Profi fejlesztő vagyok, aki szenvedélyesen épít gyönyörű, nagy teljesítményű digitális termékeket. Az elmúlt öt évben startupoknak és megalapozott vállalkozásoknak segítettem olyan weboldalakat és Android alkalmazásokat szállítani, amelyek gyorsak, megbízhatók és konverzióra lettek tervezve. Partnerként dolgozom, nem beszállítóként — az első hívástól az indulás utáni időszakig is elkötelezett vagyok az eredményed mellett.",
            values: [
                { title: "Minőség", description: "Minden pixel és minden kódsor szándékos." },
                { title: "Kommunikáció", description: "Világos beszámolók, őszinte határidők, szakzsargon nélkül." },
                { title: "Innováció", description: "Modern stack és AI ott, ahol valódi értéket teremtenek." },
                { title: "Problémamegoldás", description: "Összetett igényekből elegáns termékek." },
            ],
        },
        contact: {
            number: "08",
            label: "Kapcsolat",
            title: "Építsünk együtt valami kivételeset",
            description: "Mesélj a projektedről — minden megkeresésre személyesen válaszolok, általában 24 órán belül.",
            labels: { name: "Név *", email: "E-mail *", company: "Cég", budget: "Költségkeret", projectType: "Projekt típusa", message: "Üzenet *" },
            placeholders: { name: "A neved", email: "te@ceg.hu", company: "Cég neve", message: "Mesélj a céljaidról, a határidőkről és minden másról, ami számít." },
            selectBudget: "Válassz keretet",
            budgetOptions: ["1 000 $ alatt", "1 000 – 5 000 $", "5 000 – 10 000 $", "10 000 $ felett"],
            selectType: "Mit építünk?",
            typeOptions: ["Weboldal", "Webalkalmazás", "Android alkalmazás", "UI/UX dizájn", "Valami más"],
            errors: {
                name: "Kérlek, add meg a neved.",
                email: "Kérlek, adj meg egy érvényes e-mail címet.",
                message: "Mesélj kicsit többet a projektedről (min. 10 karakter).",
            },
            submit: "Üzenet küldése",
            sending: "Küldés…",
            toastSuccess: "Üzenet elküldve — 24 órán belül jelentkezem.",
            toastError: "Hiba történt. Próbáld újra, vagy írj közvetlenül e-mailt.",
        },
        footer: {
            copyright: "© 2026 Overlast Studio — Attila Zsók. Minden jog fenntartva.",
        },
    },
};
